import React from 'react';
import CategoryCard from './CategoryCard';
import { categoriesData } from './categoriesData';

const track = (name, props = {}) => {
  try { if (window.ahoy) window.ahoy.track(name, props); } catch (_) {}
};

const TopCategories = () => {
  const handleSeeAll = (category) => track('home_category_click', { category });
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 max-w-[100vw] overflow-x-hidden">
      {categoriesData.map((category) => (
        <CategoryCard key={category.id} category={category} onSeeAll={handleSeeAll} />
      ))}
    </div>
  );
};

export default TopCategories;


